import { render, staticRenderFns } from "./LogoPersonalizationAlert.vue?vue&type=template&id=1b200fab&scoped=true&"
import script from "./LogoPersonalizationAlert.vue?vue&type=script&lang=js&"
export * from "./LogoPersonalizationAlert.vue?vue&type=script&lang=js&"
import style0 from "./LogoPersonalizationAlert.vue?vue&type=style&index=0&id=1b200fab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b200fab",
  null
  
)

export default component.exports